import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

import { SettingsContext } from '../../../contexts';
import { getFileUrl } from '../../../core/config/api.js';

const ProductImage = ({ item }) => {
  const settings = useContext(SettingsContext);
  // Same onError-state pattern as components/ui/Avatar.jsx: when the product
  // has no images, or the file URL 404s, render the tile without a broken
  // <img> icon (the column keeps its background).
  const [broken, setBroken] = useState(false);
  const src = getFileUrl(item?.listing?.product?.images?.[0]?.id);

  return (
    <div className="col-img item-col">
      <Link to={'/product/' + item?.listing?.id + `?${settings.iframeQueryParams}`}>
        {src && !broken && (
          <img
            className="product-image"
            src={src}
            onError={() => setBroken(true)}
          />
        )}
      </Link>
    </div>
  );
};

export default ProductImage;
